import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";

import { AuthService } from "./../auth.service";
import { AppSettingsService } from "./../../shared/services/app-settings.service";
import { ViewStateService } from "./../../shared/services/view-state.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  formError: string;
  forgotPasswordForm: UntypedFormGroup;
  forgotPasswordSuccess = false;
  private formValues = { email: "" };
  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private appSettings: AppSettingsService,
    private viewState: ViewStateService,
    private router: Router
  ) {}

  ngOnInit() {
    this.buildForm();
  }

  onSubmit(updatedFormValues: any) {
    this.viewState.startLoading();

    this.formValues = updatedFormValues;
    this.validateForm();
    this.handleFormResult();
  }

  private handleFormResult() {
    this.formError = "";
    if (this.forgotPasswordForm.valid) {
      this.authService
        .forgotPassword(this.formValues.email)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (success: boolean) => {
            this.forgotPasswordSuccess = true;
            this.viewState.stopLoading();
          },
          (e) => {
            this.formError = this.validationMessages.form;
            this.viewState.stopLoading();
          }
        );
    }
  }

  private buildForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: [this.formValues.email, [Validators.required, Validators.email]],
    });
  }

  private validateForm() {
    if (!this.forgotPasswordForm) {
      return;
    }
    let hasErrors = false;

    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = "";
      const control = this.forgotPasswordForm.get(field);
      if (control && !control.valid) {
        hasErrors = true;
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
          break;
        }
      }
    }

    if (hasErrors) {this.viewState.stopLoading();}
  }

  formErrors = {
    email: "",
  };

  validationMessages = {
    email: {
      required: "Please enter a valid email.",
      email: "Please enter a valid email.",
    },
    form: "Forgot password request failed.",
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
